import { useEffect, useState } from "react";

/**
 * True once `signal` has held still for `quietMs` after `armed` (or `maxMs`
 * passed, whichever is first), per `key`. Latches until `key` changes.
 */
export function useSettled(
  key: string,
  armed: boolean,
  signal: number,
  quietMs = 120,
  maxMs = 700,
): boolean {
  const [settledKey, setSettledKey] = useState<string | null>(null);
  const settled = settledKey === key;

  useEffect(() => {
    if (!armed || settled) return;
    const cap = setTimeout(() => setSettledKey(key), maxMs);
    return () => clearTimeout(cap);
  }, [key, armed, settled, maxMs]);

  useEffect(() => {
    if (!armed || settled) return;
    const quiet = setTimeout(() => setSettledKey(key), quietMs);
    return () => clearTimeout(quiet);
  }, [key, armed, settled, signal, quietMs]);

  return settled;
}
